import Vue from 'vue'
import VueRouter from 'vue-router'

import JwtService from '@/common/jwt.service'
import { store } from '../store/index'

import CheckDevice from '../components/CheckDevice'
import NotFoundComponent from '../components/NotFound'
import DevelopComponent from '../components/Develop'


import Main from '../views/web/Main'

/*********************************************
 * 웹(WEB)
 *********************************************/
import SsoLogin from '../views/web/kiosk/logistics/sso/Login'

import Login from '../views/web/login/Login'
import FirstLoginForm from '../views/web/login/FirstLoginForm'

import FindAccount from '../views/web/account/FindAccount'

import MyPage from '../views/web/mypage/MyPage'

import ChangePW from '../views/web/account/ChangePW'

import UserList from "@/views/web/user/UserList";
import UserDetail from "@/views/web/user/UserDetail";
import UserSave from "@/views/web/user/UserSave";
import UserUpdate from "@/views/web/user/UserUpdate";

import LogisticsDashBoard from "@/views/web/kiosk/logistics/dashboard/LogisticsDashBoard.vue";
import ReceptionStatus from "@/views/web/kiosk/logistics/dashboard/ReceptionStatus.vue";
import AdminCmdpReport from "@/views/web/kiosk/logistics/dashboard/AdminCmdpReport";

import ReceiveList from "@/views/web/kiosk/logistics/receive/ReceiveList.vue";

import ManageSendList from "@/views/web/kiosk/logistics/send/SendList.vue";
import SendDetail from "@/views/web/kiosk/logistics/send/SendDetail.vue";
import SendSave from "@/views/web/kiosk/logistics/send/SendSave";
import SendUpdate from "@/views/web/kiosk/logistics/send/SendUpdate.vue";
import SendBundleSave from "@/views/web/kiosk/logistics/send/SendBundleSave";

import ReceiveDetail from "@/views/web/kiosk/logistics/receive/ReceiveDetail.vue";
import ReceiveSave from "@/views/web/kiosk/logistics/receive/ReceiveSave.vue";
import ReceiveUpdate from "@/views/web/kiosk/logistics/receive/ReceiveUpdate.vue";

import PouchList from "@/views/web/kiosk/logistics/pouch/PouchList.vue";
import PouchDetail from "@/views/web/kiosk/logistics/pouch/PouchDetail.vue";
import PouchUpsert from "@/views/web/kiosk/logistics/pouch/PouchUpsert";
import PouchBatchSave from "@/views/web/kiosk/logistics/pouch/PouchBundleSave";

import KioskList from "@/views/web/kiosk/logistics/kiosksettings/KioskList.vue";
import KioskSave from "@/views/web/kiosk/logistics/kiosksettings/KioskSave.vue";
import KioskUpdate from '@/views/web/kiosk/logistics/kiosksettings/KioskUpdate.vue';
import KioskDetail from "@/views/web/kiosk/logistics/kiosksettings/KioskDetail.vue";
import LockerList from "@/views/web/kiosk/logistics/lockersettings/LockerList.vue";
import EmergencySettings from "@/views/web/kiosk/logistics/kiosksettings/EmergencySettings.vue";

import VersionList from '@/views/web/kiosk/logistics/electron/VersionList.vue';
import VersionSave from '@/views/web/kiosk/logistics/electron/VersionSave.vue';
import VersionUpdate from '@/views/web/kiosk/logistics/electron/VersionUpdate.vue'
import VersionDetail from '@/views/web/kiosk/logistics/electron/VersionDetail.vue';

import SendRegiLabel from '@/views/web/kiosk/logistics/label/SendRegiLabel.vue'
import LockerStatus from '@/views/web/kiosk/logistics/locker/LockerStatus'
import blNoList from "@/views/web/kiosk/logistics/blno/blNoList"
import PromotionSettings from "@/views/web/kiosk/logistics/kiosksettings/PromotionSettings.vue";

import ReserveList from "@/views/mobile/logistics/reserve/ReserveList";
import ReserveDetail from "@/views/mobile/logistics/reserve/ReserveDetail";
import ReserveUpsert from "@/views/mobile/logistics/reserve/ReserveUpsert";


Vue.use(VueRouter)

// 로그인 권한이 있는지 가드 체크
const requireAuth = () => (from, to, next) => {
  const isFirstLogin = sessionStorage.getItem('isFirstLogin')
  const isExistLoginToken = sessionStorage.getItem('loginUserToken') !== null
  const authId = JSON.parse(sessionStorage.getItem('loginUserData')).authId

  if(authId === undefined || authId === null){
    kendo.alert('권한을 특정할 수 없습니다.')

    if (sessionStorage.getItem('displayMode') === 'MOBILE') {
      next('/m/login')
    } else if (sessionStorage.getItem('displayMode') === 'PC') {
      next('/login')
    }
  }


  if (isExistLoginToken) {
    // 로그인이 되어있지만 첫번째 로그인일 때
    if (isFirstLogin === 'Y') {
      next('/firstLoginForm')

    } else {

      // 로그인이 되어있을 때 && 첫번째 로그인이 아닐 때
      switch (authId){
        case "9999":
        case "1001":
        case "2001":
          store.dispatch('initSearchData')
          store.dispatch('initLogisticsData')
          // store.dispatch('LabelDeviceReset')
          return next({ name: 'LogisticsDashBoard' })
        default:
          return next({ name: 'NotFound' })
      }
    }

  } else {
    // 로그인이 안되어있을 때
    let etnersUserId
    let loginUserToken

    if(location.search.includes('?utopia=')) {
      etnersUserId = location.search.split('=')[1]
      next(`/checkDevice?utopia=${etnersUserId}`)

    }if(location.search.includes('?loginUserToken=')){
      let queryParams = location.search.split('?')[1]


      next(`/checkDevice?${queryParams}`)
    }else{

      next('/checkDevice')
    }
  }
}

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/sso/login',
      name: 'SsoLogin',
      component: SsoLogin,
      meta: {
        layout: 'LoginLayout',
      },
      props: (route) => ({ email: route.query.email, id: route.query.id, username: route.query.username }),
    },
    /***************************************************
     * 공통
     ***************************************************/
    // 페이지 찾을 수 없음
    {
      path: '/notFound',
      name: 'NotFound',
      component: NotFoundComponent
    },
    // 개발중
    {
      path: '/develop',
      name: 'Develop',
      component: DevelopComponent
    },
    // 접속기기 분석(PC / MOBILE)
    {
      path: '/checkDevice',
      name: 'CheckDevice',
      component: CheckDevice,
      props : true
    },
    // 루트 URL
    {
      path: '/',
      name: 'Main',
      component: Main,
      beforeEnter: requireAuth()
    },
    /***************************************************
     * 메뉴
     ***************************************************/
    // 2. 사용자
    // 2-1. 사용자
    {
      path: '/user',
      redirect: {
        name: 'UserList'
      }
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: UserList,
    },
    {
      path: '/user/detail/:unqUserNo',
      name: 'UserDetail',
      component: UserDetail,
    },
    {
      path: '/user/save',
      name: 'UserSave',
      component: UserSave,
    },
    {
      path: '/user/save/:unqUserNo',
      name: 'UserUpdate',
      component: UserUpdate
    },
    // 9 사내 물류
    // 9-1. 실시간 현황
    {
      path: '/logistics',
      redirect: {
        name: 'LogisticsDashBoard'
      }
    },
    {
      path:'/logistics/dashBoard',
      name:'LogisticsDashBoard',
      component:LogisticsDashBoard,
    },
    //9-2 키오스크 접수 현황
    {
      path: '/logistics/kiosk/receptionStatus',
      name:'ReceptionStatus',
      component: ReceptionStatus
    },
    //9-3 수령관리
    {
      path: '/logistics/manage/receive',
      redirect: {
        name: 'ReceiveList'
      }
    },
    {
      path:'/logistics/manage/receive/list',
      name:'ReceiveList',
      component : ReceiveList
    },
    {
      path: '/logistics/manage/receive/detail/:receiveId',
      name: 'ReceiveDetail',
      component: ReceiveDetail,
      props: true,
    },
    {
      path:'/logistics/manage/receive/save',
      name:'ReceiveSave',
      component: ReceiveSave,
    },
    {
      path:`/logistics/manage/receive/save/:receiveId`,
      name : 'ReceiveUpdate',
      component : ReceiveUpdate,
    },
    // 9-4 발송관리
    {
      path: '/logistics/manage/send',
      redirect: {
        name: 'ManageSendList'
      }
    },
    {
      path:'/logistics/manage/send/list',
      name:'ManageSendList',
      component : ManageSendList
    },
    {
      path: '/logistics/manage/send/detail/:sendId',
      name: 'SendDetail',
      component: SendDetail,
      props: true,
    },
    {
      path:'/logistics/manage/send/save/:sendScn',
      name: 'SendSave',
      component: SendSave,
      props: true,
    },
    {
      path:'/logistics/manage/send/saveRegi/:sendId',
      name: 'SendUpdate',
      component: SendUpdate,
      props: true,
    },
    {
      path: '/logistics/manage/send/save/:sendScn/bundle',
      name: 'SendBundleSave',
      component: SendBundleSave,
      props: true,
    },
    //9-5 파우치 수거 관리
    {
      path:'/logistics/manage/pouch',
      redirect:{
        name:'PouchList'
      }
    },
    {
      path:'/logistics/manage/pouch/list',
      name:'PouchList',
      component : PouchList
    },
    {
      path: '/logistics/manage/pouch/save',
      name: 'PouchSave',
      component: PouchUpsert
    },
    {
      path: '/logistics/manage/pouch/detail/:pouchId',
      name: 'PouchDetail',
      component: PouchDetail,
      props: true,
    },
    {
      path: '/logistics/manage/pouch/save/bundle',
      name: 'PouchBatchSave',
      component: PouchBatchSave,
      props: true,
    },
    {
      path: '/logistics/manage/pouch/save/:pouchId',
      name: 'PouchUpdate',
      component: PouchUpsert,
      props: true,
    },
    //9-8 물품 보관함 현황
    {
      path: '/logistics/locker',
      name:'LockerStatus',
      component : LockerStatus
    },
    {
      path: '/logistics/blno',
      name:'blNoList',
      component : blNoList
    },
    //10 키오스크 설정
    //10-1 키오스크 관리
    {
      path: '/kiosk',
      redirect: {
        name: 'KioskList'
      }
    },
    {
      path: '/kiosk/manage',
      redirect: {
        name: 'KioskList'
      }
    },
    {
      path:'/kiosk/manage/list',
      name:'KioskList',
      component : KioskList
    },
    {
      path: '/kiosk/manage/save',
      name:'KioskSave',
      component : KioskSave
    },
    {
      path: '/kiosk/manage/list/detail/:kioskNo',
      name:'KioskDetail',
      component : KioskDetail
    },
    {
      path: '/kiosk/manage/list/update/:kioskNo',
      name:'KioskUpdate',
      component : KioskUpdate
    },
    {
      path : '/kiosk/manage/list/detail/emergencySettings/:kioskNo',
      name : 'EmergencySettings',
      component : EmergencySettings,
    },
    {
      path : '/kiosk/manage/list/detail/promotionSettings/:kioskNo',
      name : 'PromotionSettings',
      component : PromotionSettings,
    },
    //10-2 무인보관함 관리
    {
      path:'/kiosk/manage/locker',
      name:'LockerList',
      component : LockerList
    },
    //10-3 일렉트론앱 버전 관리
    {
      path:'/kiosk/manage/version',
      name:'VersionList',
      component : VersionList
    },
    {
      path:'/kiosk/manage/version/save',
      name:'VersionSave',
      component : VersionSave
    },
    {
      path:'/kiosk/manage/version/detail/:versionId',
      name:'VersionDetail',
      component : VersionDetail
    },
    {
      path:'/kiosk/manage/version/update/:versionId',
      name:'VersionUpdate',
      component : VersionUpdate
    },

    // 11. 발송 예약 (모바일)
    {
      path: '/reserve',
      redirect: {
        name: 'ReserveList'
      }
    },
    {
      path:'/reserve/list',
      name:'ReserveList',
      component : ReserveList,
      meta: {
        layout: 'MobileReserveLayout'
      },
    },
    {
      path:'/reserve/detail/:sendId',
      name:'ReserveDetail',
      component : ReserveDetail,
      props: true,
      meta: {
        layout: 'MobileReserveLayout'
      },
    },
    {
      path:'/reserve/save/:sendScn',
      name:'ReserveUpsert',
      component : ReserveUpsert,
      props: true,
      meta: {
        layout: 'MobileReserveLayout'
      },
    },
    {
      path:'/reserve/save/:sendScn/:sendId',
      name:'ReserveUpdate',
      component : ReserveUpsert,
      props: true,
      meta: {
        layout: 'MobileReserveLayout'
      },
    },

    // 12. 키오스크 사용 현황
    {
      path: '/admin',
      redirect: {
        name: 'AdminCmdpReport'
      }
    },
    {
      path:'/admin/report',
      name:'AdminCmdpReport',
      component:AdminCmdpReport,
    },

   /***************************************************
     * user
     ***************************************************/
    // 로그인 페이지
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'LoginLayout'
      },
      props: true
    },
    // 회원 계정 찾기
    {
      path: '/findAccount',
      name: 'FindAccount',
      component: FindAccount,
      meta: {
        layout: 'LoginLayout',
      },
      props: true,
    },
    // 마이 페이지
    {
      path: '/mypage',
      name: 'MyPage',
      component: MyPage,
    },
    // 최초 로그인
    {
      path: '/firstLoginForm',
      name: 'FirstLoginForm',
      component: FirstLoginForm,
      meta: {
        layout: 'NoInfoHeaderLayout'
      },
    },
    // 비밀번호 변경 90일 경과
    {
      path: '/changePw',
      name: 'ChangePW',
      component: ChangePW,
      meta: {
        layout: 'NoInfoHeaderLayout',
      },
      props: true,
    },
    /***************************************************
     * Label QR 조회
     ***************************************************/
    {
      path: '/qrInfo/:sendId',
      name: 'SendRegiLabel',
      component: SendRegiLabel,
      meta: {
        layout: 'NoInfoHeaderLayout'
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 네비게이션 가드 (전역가드)
router.beforeEach(function (to, from, next) {
  const loginUserToken = sessionStorage.getItem('loginUserToken')
  const isFirstLogin = sessionStorage.getItem('isFirstLogin')
  const displayMode = sessionStorage.getItem('displayMode')


  // 접속 가능여부 체크 없이 pass 처리
  const allpassUrl = ['/login', '/firstLoginForm', '/findAccount', '/changePw', '/checkDevice', '/notFound', '/develop', '/sso/login']
  const mainUrl = ['/logistics/dashBoard']
  const allpassName = ['SendRegiLabel']
  if (allpassUrl.includes(to.path) || mainUrl.includes(to.path) || allpassName.includes(to.name)) {
    return next()
  }

  // 토큰 정보 없는 경우
  if (loginUserToken === undefined || loginUserToken === null) {
    if (from.name === 'SsoLogin' && to.name === 'ReserveList') {
      return next() // SSO 로그인의 경우
    } else {
      return next('/login')
    }
  }

  if (sessionStorage.getItem('loginUserData') !== null) {
    // 접속자 메뉴리스트
    const originalMenuData = JSON.parse(sessionStorage.getItem('loginUserData')).authMenuList
    const authId = JSON.parse(sessionStorage.getItem('loginUserData')).authId
    // // let passUrl
    // store.dispatch('initSearchData')
    //
    // if(authId === '9999' || authId === '1001' || authId === '1002'){
    //   store.dispatch('initSearchDataForEtners')
    // }
    //

    // 접속하고자 하는 메뉴가 접속자의 메뉴리스트에 있는지 확인 (접속 권한 체크)
    const boolMenuAuth = originalMenuData.some(menu => {
      return to.path === '/notFound'
          || to.path === '/'
          || menu.urlLink === to.path
          || to.path.includes(menu.urlLink + '/save')
          || to.path.includes(menu.urlLink + '/update')
          || to.path.includes(menu.urlLink + '/detail')
          || to.path.includes(menu.urlLink + '/list')
          || to.path.includes('/mypage')

    })


    if (boolMenuAuth === true) {
      /** 접속 권한이 있는 메뉴 진입인 경우 */
      return next()
    } else {
      /** 접속 권한이 없는 메뉴 진입인 경우 */
      if (from.name === undefined || from.name === null) {
        // 이전 링크가 없다면 메인화면으로 이동
        sessionStorage.removeItem('urlPath')
        return next('/notFound')
      } else {
        // 이전 화면으로 이동
        return next(from.path)
      }
    }
  } else {
    return next()
  }
})

router.afterEach((to, from) => {
  sessionStorage.setItem('LAST_ROUTE_NAME', from.name)
})

